<template>
    <div class="" style="padding:.2rem 0 8rem 0">
             <van-notice-bar 
             v-if="row.club2grade" v-rblink="{name:'MyClub'}"
                text="您已具备申请二星俱乐部资质，请尽快升级俱乐部资质。点击前往>>"
/>
        <div class="order-success">
            <div class="icon"></div>
            <div class="title">报名成功</div>
            <img :src="row.erweiimg[0].url" v-if="row.erweiimg.length>0" />
            <p v-if="row.erweiimg.length>0" style="color:#f00" >{{pageData.sqname}}<br />扫码加工作人员好友，进入赛事微信群</p>

            <div :key="hindex" v-for="(hvalue,hindex) in row.hotel_list">
                
                <img v-if="hvalue.qrpic.length>0" :src="hvalue.qrpic_url" />
                <p   v-if="hvalue.qrpic.length>0" style="color:#f00" >扫码进入 {{hvalue.title}} 咨询群</p>
            </div>
            
        </div>
            <van-cell-group>
                <van-cell
                        input-align="right"
                        title="单位"
                        :value="row.danwei"
                />
                <van-cell
                        input-align="right"
                        title="队伍"
                        :value="row.mingcheng"
                />
                <van-cell
                        input-align="right"
                        title="赛区"
                        :value="row.saiqu_name"
                />
            </van-cell-group>

        <div style="text-align: center">
            <van-button
                    v-if="row.need_video==1"
                    style="width: 3rem ; margin: 0 auto"
                    size="normal" round v-rblink="{name:'ISaiApplyVideoList',query:{id:row.id}}" >{{row.video_ok ? '视频已上传' : '上传视频'}}</van-button>
        </div>

        <van-divider>秩序册信息</van-divider>
        <van-cell-group>
            <van-cell title="赛季" :value="pageData.sjname" />
            <van-cell title="赛区" :value="pageData.sqname" />
            <van-cell title="单位" :value="pageData.danwei" />
            <van-cell title="队伍名称" :value="pageData.mingcheng" />
            <!--
            <van-cell title="健康证明" v-if="pageData.jiankangpics.length>0" >
                <a :href="pic"  v-for="pic in pageData.jiankangpics">
                    <img style="max-height: 50px; margin-left: 10px;" :src="pic" />
                </a>
            </van-cell>
            <van-cell title="健康证明" v-else value="未上传" />-->
            <van-cell title="队伍合影" v-if="pageData.heying"  >
                <a :href="pageData.heying"><img style="max-height: 50px;" :src="pageData.heying" /></a>
            </van-cell>

        </van-cell-group>
        <van-divider>人员信息</van-divider>
        <van-cell-group>
            <van-cell :key="index" title="领队" v-for="(user,index)  in pageData.lingdui_list" :value="user.name" @click="downloadMemberCert(user)" >
                <template #label> 
                    身份证:{{user.num}} <van-button v-if="pageData.showCert&&user.showCert" @click="downloadMemberCert(user)">下载证书</van-button>
                </template>
            </van-cell>
        </van-cell-group>
        <van-cell-group>
            <van-cell :key="index" :title="'教练员'+(index+1)" v-for="(user,index) in pageData.jiaolianyuan_list" :value="user.name" >
                <template #label> 
                  身份证:{{user.num}} <van-button  v-if="pageData.showCert&&user.showCert" @click="downloadMemberCert(user)">下载证书</van-button>
                </template>
            </van-cell>
        </van-cell-group>
        <van-cell-group>
            <van-cell :key="index" :title="'裁判员'+(index+1)" v-for="(user,index) in pageData.caipanyuan_list" :value="user.name"    >
                <template #label> 
                    身份证:{{user.num}}  
                </template>
            </van-cell>
        </van-cell-group>

        <van-cell-group>
            <van-cell :key="index" :title="'运动员'+(index+1)" v-for="(user,index) in pageData.yundongyuan_list" :value="user.name"   >
                <template #label> 
                  身份证:{{user.num}} <van-button  v-if="pageData.showCert&&user.showCert" @click="downloadMemberCert(user)">下载证书</van-button>
                </template>
            </van-cell>
        </van-cell-group>

        <van-divider>参赛人数</van-divider>
        <van-cell-group>
            <van-cell title="领队" value="1"  />
            <van-cell title="教练员" :value="pageData.jiaolianyuan_list.length" />
            <van-cell title="裁判员" :value="pageData.caipanyuan_list.length"  />
            <van-cell title="运动员" :value="pageData.yundongyuan_list.length"  />
            <van-cell title="总计" :value="pageData.member_total_count"  />
        </van-cell-group>

        <div class="savebtn">
            <van-button
                    color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                    style="width: 3rem"
                    size="normal" round  v-rblink="{name:'MineIndex',query:{}}">返回首页</van-button>
            <van-button
                    color=""
                    style="width: 3rem"
                    size="normal" round  @click="download">下载明细表</van-button>
        </div>

        <div v-for="(subject,index) in pageData.subject">
            <van-divider>项目{{index+1}}</van-divider>
            <van-cell-group>
                <van-cell title="项目" :label="subject.subject_name" />
                <van-cell title="参赛队员"   />
                <div class="memberResultWrap" v-show="subject.yundongyuan.length>0">
                    <div class="memberLi" v-for="(yundongyuan ,index) in subject.yundongyuan">
                        运动员{{index+1}}
                        <van-tag

                                :key="index"
                                round
                                color="#fff"
                                text-color="#666"
                                size="large"
                                type="primary"
                                @close="subject.yundongyuan.splice(index,1)"
                        > {{yundongyuan.name}} {{yundongyuan.num}}
                        </van-tag>
                    </div>
                </div>

                <van-cell title="教练员"  />

                <div class="memberResultWrap" v-show="subject.jiaolian.length>0">
                    <div class="memberLi" v-for="(jiaolian ,index) in subject.jiaolian">
                        教练员{{index+1}}
                        <van-tag

                                :key="index"
                                round
                                color="#fff"
                                text-color="#666"
                                size="large"
                                type="primary"
                        > {{jiaolian.name}} {{jiaolian.num}}
                        </van-tag>
                    </div>
                </div>
                <van-cell title="替补队员"   />

                <div class="memberResultWrap" v-show="subject.tbydy.length>0">
                    <div class="memberLi" v-for="(tbydy ,index) in subject.tbydy">
                        替补运动员{{index+1}}
                        <van-tag

                                :key="index"
                                round
                                color="#fff"
                                text-color="#666"
                                size="large"
                                type="primary"
                        > {{tbydy.name}} {{tbydy.num}}
                        </van-tag>
                    </div>
                </div>

                <van-cell title="自选音乐" is-link v-if="subject.sf_music_status==false&&subject.music_url" >
                    <a :href="subject.music_url">已上传</a>
                </van-cell>
                <van-cell title="自选音乐" is-link v-if="subject.sf_music_status==false&&subject.music_url==''&&subject.music_status==1" @click='showMusicDialog=true;musicSubjectId=subject.id' >
                    <em style="color: #ff0000">现在上传/现场提交</em>
                </van-cell>
                <van-cell title="音乐试听" is-link @click="listen(subject)" v-if="subject.sf_music_status==false&&subject.music_url&&subject.music_status==1" >
                    <em style="color: #ff0000">未试听,请点击确认试听</em>
                </van-cell>
                <van-cell title="音乐试听"  v-if="subject.sf_music_status==false&&subject.music_url&&subject.music_status==2" >
                     已试听
                </van-cell>
                <van-cell title="音乐试听"  v-if="subject.sf_music_status==false&&subject.music_status==3" >
                     现场提交并核对
                </van-cell>
                <!-- <van-cell title="现场照片服务" :value="subject.photo_service==1?'是':'否'" /> -->
            </van-cell-group>

        <div v-if="pageData.room_list.length>0">
            <van-divider>食宿信息</van-divider>
                <van-cell-group> 
                    <van-cell
                            v-for="(room,rindex) in orderData2.list"
                            :key="rindex"
                            input-align="right"
                            :title="room.name"
                            :value="room.count"
                    >  
                    <span  >
                    {{room.count}}
                    </span>

                    </van-cell>
    


                </van-cell-group>
        </div>
            

        </div>

    <van-action-sheet
        v-model="ltShow"
        :actions="ltActions"
        cancel-text="取消"
        @select="onLtSelect"
        close-on-click-action
        @cancel="ltShow=false"
    />

        <van-popup v-model="showCert" style="width: 80%; height: auto ; text-align: center">
            <img :src="certUrl"  style="width: 100%; text-align: center; height: auto"  />
            <van-button  v-if="!isApp" style="margin: 10px auto; text-align: center " type="default" round>请长按图片保存</van-button>
            <van-button v-else @click="appDownload" style="margin: 10px auto; text-align: center " type="default" round>点击下载证书</van-button>
        </van-popup>
        <van-overlay :show="loading"    >
        <van-loading type="spinner" v-model="loading" style="text-align: center ; margin-top: 200px;" />
        </van-overlay>

    </div>

    
</template>
<style scoped>
    .box {
        /*margin-bottom: 1.5rem;*/
    }

    .order-success{
        text-align: center;
        margin: 20px 0 ;
    }
    .order-success .icon{
        background: url(../../../assets/images/icon-order-done.png);
        background-size: 100%;
        width: 75px;
        height: 75px;
        margin: 20px auto 20px auto;

    }
    .order-success .title{
        font-size: 18px;
        font-weight: bold;
        color: #000;
        text-align: center;
    }
    .order-success img{
        width: 120px;
        height: 120px;
        margin: 10px auto;
    }
    .order-success p{
        font-size: 12px;
        color: #999;
    }

    .sai-shuo-li{
        background: #f3f3f3;
        border-radius: 10px;
        margin: 20px 10px ;
        padding: 10px;
    }
    .sai-shuo-li img{
        width: 50px;
        height: 50px;
        border-radius: 6px;
        float: left;
        margin-right: 10px;
    }
    .sai-shuo-li .c{
        width: calc(100% - 80px);
        border-right: 1px solid #00000008 ;
    }
    .sai-shuo-li .c .title{
        font-size: 14px;
        color: #000;
    }
    .sai-shuo-li .c .desc{
        font-size: 12px;
        color: #999;
    }
    .sai-shuo-li .fr{
        width: 70px;
        float: right;
    }
    .sai-shuo-li .btn{
        width: 60px;
        height: 26px;
        line-height: 26px;
        font-size: 12px;
        text-align: center;
        background:linear-gradient(90deg,rgba(254,200,53,1) 0%,rgba(255,173,25,1) 100%);
        border-radius:6px;
        color: #fff;
    }
    .savebtn {
        position: fixed;
        bottom: 0;
        padding-bottom: 0.2rem;
        width: 100%;
        z-index: 10;
        display: flex;
        flex: 1;
        flex-direction: row;
        justify-content: space-around;
        background: linear-gradient(180deg,hsla(0,0%,100%,0),#fff);
    }

    .memberResultWrap{
        background: #F3F3F3;
        margin: 0.2rem;
        border-radius: 8px;
        padding: 0.2rem;
    }
    .memberResultWrap .memberLi{
        font-size: 14px;
        color: #666;
        /* height: 36px; */
        line-height: 36px;
    }
    .memberResultWrap .memberLi .van-tag{
        width: auto !important;
    }


</style>
<script>
    import Vue from 'vue';
    import area from "../../../utils/area";
    import validator from "../../../utils/validator";
    import PicUploader from '@/components/picker/PicUploader.vue';
    import FileUploader from '@/components/picker/FileUploader.vue';

    import {Cell,Field,Area,Form,Divider, CellGroup,RadioGroup,Radio,ActionSheet,Dialog,Icon, Toast, Popup, Picker, Sidebar, SidebarItem, Tag, Stepper ,Switch ,Button} from 'vant';
    import CaipanPicker from '@/components/picker/CaipanPicker.vue';
    import FamliyPicker from '@/components/picker/FamliyPicker.vue';

    import jquery from 'jquery';

    Vue.use(Cell).use(CellGroup).use(Form).use(Divider).use(Area).use(ActionSheet).use(Dialog).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
            .use(Switch).use(Button);
    export default {
        name: 'SaiApplyFormStep2',
        components: {
            [Field.name]: Field,
            PicUploader,
            FileUploader,
        },
        data: function () {
            return {
                validator,
                saveLoading:false,
                showFamliyPicker:false,
                showSubjectPicker:false,
                showJiaolianPicker:false,
                showRoomTypePicker:false,
                showMemberPicker:false,
                formData:{
                    id:0
                },
                row:{
                    club2grade:false,
                    erweiimg:[],
                    hotel_list:[],
                },
                pageData:{
                    showCert:false,
                    'jiankangpics' :[],
                    'lingdui_list' :[],
                    'yundongyuan_list' :[],
                    'jiaolianyuan_list' :[],
                    'caipanyuan_list' :[],
                    'room_type' :[],
                    'room_list' :[],
                }, 

                ltImgSrc: '',
                ltImgName: '',
                ltActions: [{name: '保存图片'}],

                ltShow: false,


                loading:false,
                showCert:false,
                saveLoading:false,  
                certUrl:'',
                filename:'',
                isApp:window.isApp(),
            }
        },
        filters: {},

        computed:{
            orderData2(){
                let list = [];
                let price = 0;
                let count = 0;
                let that = this;
                this.pageData.room_type.map((roomType) =>{
                    let roomTypeRow = {
                        name : roomType.name,
                        price : roomType.price,
                        count : 0
                    }
                    that.pageData.room_list.map((room) =>{
                        if(room.room_id==roomType.id){
                            roomTypeRow.count ++;
                            count += room.member.length
                        }
                    });
                    list.push(roomTypeRow);
                });
                list.map((rvalue) =>{
                    price += rvalue.price * rvalue.count;
                });
                return {
                    list :list,
                    price :price,
                    count:count
                }
            } ,
        },
        mounted() {

            document.title = '报名成功';
            let that = this;
            that.areaList = area;
            that.formData.id = this.$route.query.id;
            if(that.formData.id){
                this.fetch();
            }
        },
        watch: {
            formData() {
            }
        },
        destroyed() {
        },
        methods: {
            onQuestion(){
                console.log('onQuestion')
            }, 
            onLtSelect(item) {
            let that = this;
            switch (item.name) {
                case '保存图片':
                console.log(that.ltImgSrc, that.ltImgName);
                appEvent({
                    name: 'downloadPic',
                    query: {
                    'filename': that.ltImgName,
                    'url': that.ltImgSrc
                    }
                });
                break;
            }
            },
            download(file) {
            // 判断如果是PDF文件 直接在页面中打开 vue-pdf??

            appEvent({
                name: 'downloadFile',
                query: {
                name: file.name,
                url: file.url,
                }
            });
            },
            
            download(){
                appEvent({
                name: "downloadFile",
                query: { url: window.root+'/api/isai/detailDownload?id='+this.row.id },
                });
            },
            onMemberConfirm(values){
                console.log('onMemberConfirm',values)
                this.showMemberPicker = false;
                this.formData.member = [...values];
            },
            onMemberChange(values){
                console.log('onMemberChange',values)
                this.formData.member = [...values];
            },
            onRoomTypeConfirm(value, index){
                this.formData.roomTypeName = value;
                this.formData.roomtype = index+1;
                this.showRoomTypePicker = false;
            },
            downloadMemberCert(member){

                let that = this;
                that.loading = true;
                that.$api.post('/api/sai/getcert509', {
                    member_id:member.id
                }, (res) => {
                    console.log(res);
                    that.loading = false;
                    that.showCert = true;
                    that.certUrl = res.data.url;
                    that.filename = res.data.filename;
                }, (res) => {
                    that.loading = true;
                    Toast.fail(res.msg);
                })
            },
            appDownload(){
                let that = this;
                console.log('downloadPic');
                appEvent({
                    name: 'downloadPic',
                    query: {
                        filename: that.filename.replace(".pdf",''),
                        url:that.certUrl,
                    }
                });
            },
            fetch(){
                let that = this;
                that.$api.post('/api/isai/successdetail', {
                    id:that.formData.id
                }, (res) => {
                    that.row = res.data;
                    that.pageData = res.data;

                    if(this.row.erweiimg.length>0){
                        Dialog.confirm({
                            title: '报名须知',
                            message: '您已报名成功，请务必扫码进群',
                            confirmButtonText:'我知道了', 
                            showCancelButton:false
                        }).then(() => {
                        // on close 
                        }).catch(() => { 
                        });
                    }


                    // if (window.isApp()) {
                    if (true) {
                    setTimeout(() => {
                        jquery('img').each(function () {
                        jquery(this).longPress(() => {
                            console.log('longPress', jquery(this).attr('src'));
                            that.ltImgSrc = jquery(this).attr('src')
                            that.ltImgName = jquery(this).attr('title')
                            that.ltShow = true;
                        });
                        })
                    }, 500);
                    return false;
                    }
                }, (res) => {
                    Toast.fail(res.msg);
                })
            }

        }
    }
</script>



// WEBPACK FOOTER //
// SaiApplyFormSuccess.vue?5c67e52f